import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { FiveTabWidget } from './FiveTabWidget';

const theme = createTheme('uhc', { enterpriseFont: true });

export const Widget = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <FiveTabWidget {...props} />
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/FiveTabWidget';

Widget.propTypes = {
  data: PropTypes.shape({
    tabIndex: PropTypes.number,
    setTabIndex: PropTypes.func,
    user: PropTypes.shape({}),
    widgetTabs: PropTypes.arrayOf(PropTypes.shape({})),
    permissionsContext: PropTypes.string,
    breakPoint: PropTypes.number,
  }),
};

Widget.defaultProps = {
  data: {},
};
